/* LaClique Landing kit — comportements légers (compte à rebours, barres, compteurs, carrousel)
   Chargé en defer, aucune dépendance. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Observer partagé : déclenche `lc:visible` une seule fois par élément */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          e.target.dispatchEvent(new CustomEvent('lc:visible'));
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' })
    : null;
  function onVisible(el, fn) {
    if (!io) { fn(); return; }
    el.addEventListener('lc:visible', fn, { once: true });
    io.observe(el);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- <lc-countdown> ----------
     data-mode : "daily"   → jusqu'à minuit (heure locale du visiteur)
                 "minutes" → durée fixe, persistée par visiteur (data-minutes, data-key)
                 "date"    → jusqu'à une date ISO (data-date)
     Rend dans les enfants [data-unit="h|m|s"] si présents, sinon dans .lc-time (HH:MM:SS). */
  var Countdown = function () { return Reflect.construct(HTMLElement, [], Countdown); };
  Countdown.prototype = Object.create(HTMLElement.prototype);
  Countdown.prototype.connectedCallback = function () {
    var self = this;
    var mode = this.dataset.mode || 'daily';
    var target;
    if (mode === 'date' && this.dataset.date) {
      target = new Date(this.dataset.date).getTime();
    } else if (mode === 'minutes') {
      var key = 'lc_cd_' + (this.dataset.key || 'default');
      var minutes = parseInt(this.dataset.minutes || '15', 10);
      var saved = null;
      try { saved = localStorage.getItem(key); } catch (e) {}
      target = saved ? parseInt(saved, 10) : 0;
      if (!target || target < Date.now()) {
        target = Date.now() + minutes * 60000;
        try { localStorage.setItem(key, String(target)); } catch (e) {}
      }
    } else {
      var d = new Date(); d.setHours(24, 0, 0, 0); target = d.getTime();
    }
    var units = { h: this.querySelector('[data-unit="h"]'), m: this.querySelector('[data-unit="m"]'), s: this.querySelector('[data-unit="s"]') };
    var out = this.querySelector('.lc-time');
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var h = Math.floor(diff / 3600000), m = Math.floor(diff / 60000) % 60, s = Math.floor(diff / 1000) % 60;
      if (units.h || units.m || units.s) {
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
      } else if (out) {
        out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      if (diff <= 0 && mode === 'daily') { var n = new Date(); n.setHours(24, 0, 0, 0); target = n.getTime(); }
    }
    tick();
    this._timer = setInterval(tick, 1000);
    self.setAttribute('data-ready', '');
  };
  Countdown.prototype.disconnectedCallback = function () { clearInterval(this._timer); };
  if (!customElements.get('lc-countdown')) customElements.define('lc-countdown', Countdown);

  /* ---------- <lc-progress data-percent="89"> ---------- */
  var Progress = function () { return Reflect.construct(HTMLElement, [], Progress); };
  Progress.prototype = Object.create(HTMLElement.prototype);
  Progress.prototype.connectedCallback = function () {
    var fill = this.querySelector('.lc-progress__fill');
    var pct = Math.min(100, Math.max(0, parseFloat(this.dataset.percent || '0')));
    if (!fill) return;
    onVisible(this, function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
  };
  if (!customElements.get('lc-progress')) customElements.define('lc-progress', Progress);

  /* ---------- <lc-counter data-to="96" data-duration="1400"> ---------- */
  var Counter = function () { return Reflect.construct(HTMLElement, [], Counter); };
  Counter.prototype = Object.create(HTMLElement.prototype);
  Counter.prototype.connectedCallback = function () {
    var self = this;
    var to = parseFloat(this.dataset.to || '0');
    var duration = parseInt(this.dataset.duration || '1400', 10);
    var decimals = (String(this.dataset.to || '').split('.')[1] || '').length;
    if (reduceMotion) { self.textContent = to.toFixed(decimals); return; }
    onVisible(this.closest('.lc-stat') || this.parentElement || this, function () {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        self.textContent = (to * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  };
  if (!customElements.get('lc-counter')) customElements.define('lc-counter', Counter);

  /* ---------- <lc-carousel> : boutons prev/next sur une piste scroll-snap ---------- */
  var Carousel = function () { return Reflect.construct(HTMLElement, [], Carousel); };
  Carousel.prototype = Object.create(HTMLElement.prototype);
  Carousel.prototype.connectedCallback = function () {
    var track = this.querySelector('[data-track]');
    if (!track) return;
    var step = function () { var first = track.firstElementChild; return first ? first.getBoundingClientRect().width + 16 : track.clientWidth; };
    var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var autoplay = parseInt(this.dataset.autoplay || '0', 10);
    if (autoplay > 0 && !reduceMotion) {
      var timer = setInterval(function () {
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, autoplay * 1000);
      this.addEventListener('pointerenter', function () { clearInterval(timer); }, { once: true });
    }
  };
  if (!customElements.get('lc-carousel')) customElements.define('lc-carousel', Carousel);

  /* ---------- .lc-reveal ---------- */
  document.querySelectorAll('.lc-reveal').forEach(function (el) { onVisible(el, function () { el.classList.add('is-visible'); }); });

  /* ---------- Liens ancrés "#lc-offer" → scroll doux vers le sélecteur d'offre ---------- */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href^="#lc-"]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  });
})();

/* ==========================================================================
   Kit AIDA — comportements supplémentaires
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Ajout direct au panier + ouverture du panier coulissant Shrine ----------
     <a class="lc-btn" data-lc-atc="VARIANT_ID" data-qty="1" href="/cart">…</a>
     Utilise /cart/add.js avec rendu des sections du drawer (même mécanique que le thème). */
  function openCartDrawer(json) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try { drawer.classList.remove('is-empty'); drawer.renderContents(json); return true; } catch (e) {}
    }
    return false;
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-lc-atc]');
    if (!btn) return;
    ev.preventDefault();
    var id = parseInt(btn.dataset.lcAtc, 10);
    if (!id) { window.location.href = btn.getAttribute('href') || '/cart'; return; }
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    if (!sections.length) sections = ['cart-drawer', 'cart-icon-bubble'];
    btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: id, quantity: parseInt(btn.dataset.qty || '1', 10) }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (json) {
      btn.removeAttribute('aria-busy');
      if (json.status) { window.location.href = '/cart'; return; }
      if (!openCartDrawer(json)) window.location.href = '/cart';
    }).catch(function () { btn.removeAttribute('aria-busy'); window.location.href = '/cart'; });
  });

  /* ---------- Timeline scientifique : remplissage + étape active au scroll ---------- */
  document.querySelectorAll('.lc-science__steps').forEach(function (steps) {
    var items = steps.querySelectorAll('.lc-science__item');
    var fill = steps.querySelector('.lc-science__track-fill');
    if (!items.length) return;
    function update() {
      var rect = steps.getBoundingClientRect();
      var mid = window.innerHeight * 0.55;
      var p = Math.min(1, Math.max(0, (mid - rect.top) / rect.height));
      if (fill) fill.style.setProperty('--lc-fill', (p * 100) + '%');
      items.forEach(function (it) { it.classList.toggle('is-active', it.getBoundingClientRect().top < mid); });
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  });

  /* ---------- "Lire la suite" sur les avis ---------- */
  document.querySelectorAll('.lc-review__text[data-clamp]').forEach(function (p) {
    p.classList.add('is-clamped');
    requestAnimationFrame(function () {
      if (p.scrollHeight <= p.clientHeight + 2) { p.classList.remove('is-clamped'); return; }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lc-review__readmore'; b.textContent = p.dataset.clamp || 'Lire la suite';
      b.addEventListener('click', function () { p.classList.remove('is-clamped'); b.remove(); });
      p.insertAdjacentElement('afterend', b);
    });
  });

  /* ---------- Modale (ingrédients) : [data-lc-modal-open="#id"] / [data-lc-modal-close] ---------- */
  document.addEventListener('click', function (ev) {
    var o = ev.target.closest && ev.target.closest('[data-lc-modal-open]');
    if (o) { ev.preventDefault(); var m = document.querySelector(o.dataset.lcModalOpen); if (m) { m.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } return; }
    var c = ev.target.closest && ev.target.closest('[data-lc-modal-close]');
    if (c) { var mm = c.closest('.lc-modal'); if (mm) { mm.removeAttribute('open'); document.body.style.overflow = ''; } }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') document.querySelectorAll('.lc-modal[open]').forEach(function (m) { m.removeAttribute('open'); document.body.style.overflow = ''; }); });

  /* ---------- Stock bas : nombre mémorisé par visiteur (décroît lentement) ---------- */
  document.querySelectorAll('[data-lc-stock]').forEach(function (el) {
    var min = parseInt(el.dataset.min || '20', 10), max = parseInt(el.dataset.max || '120', 10), key = 'lc_stock_' + (el.dataset.lcStock || 'default');
    var n = null;
    try { n = parseInt(localStorage.getItem(key), 10); } catch (e) {}
    if (!n || n < min) { n = Math.floor(min + Math.random() * (max - min)); }
    else if (Math.random() < 0.5 && n > min) { n -= 1; }
    try { localStorage.setItem(key, String(n)); } catch (e) {}
    el.textContent = n;
  });

  /* ---------- Dots de carrousel : <lc-carousel> avec [data-dots] ---------- */
  document.querySelectorAll('lc-carousel').forEach(function (car) {
    var track = car.querySelector('[data-track]'), dots = car.querySelector('[data-dots]');
    if (!track || !dots) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    slides.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Aller à ' + (i + 1));
      b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      dots.appendChild(b);
    });
    function sync() {
      var x = track.scrollLeft + track.clientWidth / 2, idx = 0;
      slides.forEach(function (s, i) { if (s.offsetLeft - track.offsetLeft < x) idx = i; });
      Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    sync(); track.addEventListener('scroll', sync, { passive: true });
  });
})();
